export default "https://cdn-static.gokick.com/assets/3c8eadbe8dc90fc8bfe5d2560afe7db765946837/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";